const Modal = ({ children, isOpen, closeModal }) => {
  return (
    <div className="!leap-z-[999999999999]">
      {isOpen && (
        <div className="leap-fixed leap-overflow-auto leap-inset-0  leap-bg-black/50 leap-flex leap-justify-center leap-items-center">
          <div
            className="leap-bg-transparent !leap-relative leap-p-6 leap-rounded leap-shadow-lg"
            style={
              {
                // Change to absolute
                // Match parent height if necessary
              }
            }
          >
            {children}
          </div>
        </div>
      )}
    </div>
  );
};

export default Modal;
